export const Constants = {
  // imagebase: "http://localhost:5000/uploads/",
  // imagebase: "http://54.157.240.144/uploads/",
  // imagebase: "/ima/uploads/",
  imagebase: "https://api.idealign.in/uploads/",
};
